<div class="modal-header">
  <div class="confirm">
    <i class="fa fa-exclamation-circle confirm"></i>
    <h2 class="confirm">{{title}}</h2>
  </div>
</div>
<div class="modal-body">
  <p class="confirm">
    {{mainText}}
  </p>
</div>
<div class="modal-footer btns-group">
  <ui-btn *ngIf="renderBtnOK" [btn]="{ label: okText, id: okId }" (click)="callBtnEvent($event); close(true)"></ui-btn>
  <ui-btn *ngIf="renderBtnCancel" [btn]="{ label: cancelText, alt: true, id: cancelId }" (click)="close(true)"></ui-btn>
</div>
